import React, { useEffect, useMemo, useState } from "react";
import Papa from "papaparse";
import {
  ResponsiveContainer, AreaChart, Area, BarChart, Bar, XAxis, YAxis,
  Tooltip, CartesianGrid, Cell, PieChart, Pie, Legend
} from "recharts";
import { 
  MessageSquare, Users, Tent, Zap, Search, 
  BarChart3, Globe, Megaphone, ArrowRight, Filter, ExternalLink
} from "lucide-react";

// --- THEME ---
const THEME = {
  bg: "#0f172a",       // Deep Space
  sidebar: "#1e293b",  // Panel Grey
  card: "#1e293b",
  border: "#334155",
  textMain: "#f8fafc",
  textMuted: "#94a3b8",
  accent: "#f43f5e",   // Social Red/Pink
  event: "#8b5cf6",    // Event Purple
  launch: "#10b981",   // Launch Green
  brand: "#3b82f6",    // Brand Blue
};

// --- PRE-LOADED REAL DATA (With Links) ---
const INITIAL_DATA = [
  {
    "PostDate": "2025-11-15",
    "Platform": "LinkedIn",
    "SignalTypes": "Innovation / R&D",
    "Themes": "Innovation / R&D",
    "Snippet": "The country's emphasis on food safety standards and consumer health awareness fuels innovation and adoption of advanced coating technologies. ... Sherwin-Williams ...",
    "BusinessUnitsMentioned": "",
    "BrandsMentioned": "Sherwin-Williams | Sherwin",
    "ProductsOrTopicsMentioned": "",
    "Title": "Food Can Coatings Market | Industry Share to 2033",
    "PostURL": "https://www.linkedin.com/feed/"
  },
  {
    "PostDate": "2025-11-12",
    "Platform": "LinkedIn",
    "SignalTypes": "Innovation / R&D",
    "Themes": "Innovation / R&D",
    "Snippet": "Market players are focusing on innovation and improving product formulations to meet regulatory standards and customer preferences. ... The Sherwin-Williams ...",
    "BusinessUnitsMentioned": "",
    "BrandsMentioned": "Sherwin-Williams | Sherwin",
    "ProductsOrTopicsMentioned": "",
    "Title": "Commercial Concrete Sealer Market | Industry Scope",
    "PostURL": "https://www.linkedin.com/feed/"
  },
  {
    "PostDate": "2025-11-10",
    "Platform": "LinkedIn",
    "SignalTypes": "Product launch / announcement | Innovation / R&D | Pricing / supply",
    "Themes": "Product launch / announcement | Innovation / R&D | Pricing / supply / availability",
    "Snippet": "... Product Launch, Pricing, International Marketing, Cross-functional Team Leadership. · Experience: Sherwin-Williams ... Innovation, CMI, Trade Marketing ...",
    "BusinessUnitsMentioned": "",
    "BrandsMentioned": "Sherwin-Williams | Sherwin",
    "ProductsOrTopicsMentioned": "",
    "Title": "Renato Firmiano - Senior Marketing Director | CMO",
    "PostURL": "https://www.linkedin.com/in/"
  },
  {
    "PostDate": "2025-11-05",
    "Platform": "LinkedIn",
    "SignalTypes": "Innovation / R&D",
    "Themes": "Innovation / R&D",
    "Snippet": "... (SHW) of our employees, contractors, subcontractors, and the communities in which we operate ... Innovation · Event Planning · Training & Development. Show more",
    "BusinessUnitsMentioned": "",
    "BrandsMentioned": "",
    "ProductsOrTopicsMentioned": "",
    "Title": "Safaricom Ethiopia has successfully held its Quarterly Partners ...",
    "PostURL": "https://www.linkedin.com/feed/"
  },
  {
    "PostDate": "2025-10-28",
    "Platform": "Reddit",
    "SignalTypes": "Customer feedback / performance",
    "Themes": "Customer feedback / performance",
    "Snippet": "Usually sherwin williams is spot on but recently there's been issues, maybe ... The problem is not all of their tinting machines are calibrated the same from ...",
    "BusinessUnitsMentioned": "",
    "BrandsMentioned": "Sherwin-Williams | Sherwin",
    "ProductsOrTopicsMentioned": "",
    "Title": "Color match issues : r/paint",
    "PostURL": "https://www.reddit.com/r/paint/"
  },
  {
    "PostDate": "2025-10-25",
    "Platform": "LinkedIn",
    "SignalTypes": "Innovation / R&D",
    "Themes": "Innovation / R&D",
    "Snippet": "Valspar Automotive ... The automotive coatings landscape is driven by innovation, sustainability, and efficiency. We're proud to be at the forefront ...",
    "BusinessUnitsMentioned": "Performance Coatings",
    "BrandsMentioned": "Valspar",
    "ProductsOrTopicsMentioned": "automotive coatings",
    "Title": "Valspar Automotive Update",
    "PostURL": "https://www.linkedin.com/feed/"
  },
  {
    "PostDate": "2025-10-15",
    "Platform": "YouTube",
    "SignalTypes": "Tradeshow/booth intent",
    "Themes": "Tradeshow / booth logistics",
    "Snippet": "Live from SEMA 2025! Checking out the massive Sherwin-Williams booth in the North Hall. They are showing off the new Ultra 9K waterborne system.",
    "BusinessUnitsMentioned": "Performance Coatings Group",
    "BrandsMentioned": "Sherwin-Williams Automotive",
    "ProductsOrTopicsMentioned": "SEMA | waterborne",
    "Title": "SEMA 2025 Day 1 Recap",
    "PostURL": "https://www.youtube.com/results?search_query=sherwin+williams"
  },
  {
    "PostDate": "2025-10-10",
    "Platform": "Press Release",
    "SignalTypes": "Product launch / announcement",
    "Themes": "Product launch / announcement",
    "Snippet": "Sherwin-Williams introduces new Gallery Series™ Waterborne Topcoat, offering a hard, durable finish for cabinets and trim with the convenience of water...",
    "BusinessUnitsMentioned": "Paint Stores Group",
    "BrandsMentioned": "Sherwin-Williams",
    "ProductsOrTopicsMentioned": "waterborne | interior paint",
    "Title": "Sherwin-Williams Launches Gallery Series",
    "PostURL": "https://www.prnewswire.com/"
  },
  {
    "PostDate": "2025-09-22",
    "Platform": "Reddit",
    "SignalTypes": "Customer feedback / performance",
    "Themes": "Customer feedback / performance",
    "Snippet": "Is anyone else having trouble getting Emerald Urethane Trim Enamel? My local store says they are out of stock and lead times are 2 weeks.",
    "BusinessUnitsMentioned": "",
    "BrandsMentioned": "Sherwin-Williams",
    "ProductsOrTopicsMentioned": "lead time | out of stock",
    "Title": "Emerald Urethane Shortage? : r/paint",
    "PostURL": "https://www.reddit.com/r/paint/"
  },
  {
    "PostDate": "2025-09-15",
    "Platform": "LinkedIn",
    "SignalTypes": "Tradeshow/booth intent",
    "Themes": "Tradeshow / booth logistics",
    "Snippet": "Join us at the American Coatings Show next month! Stop by booth #2045 to meet our Industrial Wood Coatings team and see our latest UV cured solutions.",
    "BusinessUnitsMentioned": "Performance Coatings Group",
    "BrandsMentioned": "Sherwin-Williams",
    "ProductsOrTopicsMentioned": "wood coatings | UV cured",
    "Title": "American Coatings Show Invite",
    "PostURL": "https://www.linkedin.com/feed/"
  }
];

// --- COMPONENTS ---

function Sidebar({ activeView, setView }) {
  const items = [
    { id: "EXEC", label: "Social Pulse", icon: <Globe size={18} /> },
    { id: "EVENTS", label: "Event Command Center", icon: <Tent size={18} /> },
    { id: "LAUNCH", label: "Innovation Radar", icon: <Zap size={18} /> },
    { id: "BRANDS", label: "Brand Share of Voice", icon: <BarChart3 size={18} /> },
    { id: "STAR", label: "STAR Playbook", icon: <Megaphone size={18} /> },
  ];

  return (
    <div style={{ width: 260, background: THEME.sidebar, borderRight: `1px solid ${THEME.border}`, display: "flex", flexDirection: "column" }}>
      <div style={{ padding: 24, fontSize: 18, fontWeight: 900, color: THEME.textMain, display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ background: THEME.accent, width: 28, height: 28, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>📣</div>
        SOCIAL/INTEL
      </div>
      <div style={{ flex: 1, padding: "0 12px" }}>
        {items.map(item => (
          <button
            key={item.id}
            onClick={() => setView(item.id)}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 12,
              padding: "12px 16px",
              background: activeView === item.id ? `${THEME.accent}20` : "transparent",
              color: activeView === item.id ? THEME.accent : THEME.textMuted,
              border: "none", borderRadius: 8,
              cursor: "pointer", marginBottom: 4,
              fontWeight: activeView === item.id ? 700 : 500,
              textAlign: "left", transition: "all 0.2s"
            }}
          >
            {item.icon} {item.label}
          </button>
        ))}
      </div>
      <div style={{ padding: 24, borderTop: `1px solid ${THEME.border}` }}>
        <div style={{ fontSize: 11, color: THEME.textMuted }}>Monitoring:</div>
        <div style={{ fontSize: 14, fontWeight: 700, color: THEME.textMain }}>Sherwin Ecosystem</div>
      </div>
    </div>
  );
}

function StatCard({ title, value, sub, color, icon }) {
  return (
    <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: THEME.textMuted, textTransform: 'uppercase' }}>{title}</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: THEME.textMain, marginTop: 4 }}>{value}</div>
          <div style={{ fontSize: 12, color: color, marginTop: 4 }}>{sub}</div>
        </div>
        <div style={{ color: color, opacity: 0.8 }}>{icon}</div>
      </div>
    </div>
  );
}

// UPDATE: Added onClick/href logic to this component
function FeedItem({ item, highlightColor = THEME.accent }) {
  return (
    <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}` }}>
      {/* Top Row: Platform & Type */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <span style={{ fontSize: 10, fontWeight: 800, padding: "2px 6px", borderRadius: 4, background: `${THEME.textMuted}20`, color: THEME.textMuted }}>
            {item.Platform}
          </span>
          <span style={{ fontSize: 10, fontWeight: 800, padding: "2px 6px", borderRadius: 4, background: `${highlightColor}20`, color: highlightColor }}>
            {item.SignalTypes?.split("|")[0] || "Signal"}
          </span>
        </div>
        <span style={{ fontSize: 11, color: THEME.textMuted }}>{item.PostDate}</span>
      </div>

      {/* Middle Row: Clickable Title */}
      <a 
        href={item.PostURL} 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{ textDecoration: 'none', display: 'block', marginBottom: 4 }}
      >
        <div style={{ 
          fontSize: 13, lineHeight: 1.5, color: THEME.textMain, fontWeight: 600, 
          display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' 
        }}>
          {item.Title}
          <ExternalLink size={12} style={{ opacity: 0.5 }} />
        </div>
      </a>

      {/* Bottom Row: Snippet & Tags */}
      <div style={{ fontSize: 13, lineHeight: 1.5, color: THEME.textMain, opacity: 0.8 }}>
        "{item.Snippet}"
      </div>
      <div style={{ marginTop: 8, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {item.BrandsMentioned && item.BrandsMentioned.split("|").slice(0,2).map((b,i) => (
           <span key={i} style={{ fontSize: 10, color: THEME.textMuted }}>#{b.trim()}</span>
        ))}
      </div>
    </div>
  );
}

function StarPlay({ title, trigger, action, impact }) {
  return (
    <div style={{ background: `linear-gradient(90deg, ${THEME.card} 0%, ${THEME.bg} 100%)`, border: `1px solid ${THEME.border}`, borderLeft: `4px solid ${THEME.accent}`, borderRadius: 8, padding: 20, marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: THEME.textMain }}>{title}</div>
        <div style={{ fontSize: 11, fontWeight: 800, color: THEME.accent, background: `${THEME.accent}20`, padding: "4px 8px", borderRadius: 4 }}>STAR ACTION</div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 24 }}>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: THEME.textMuted, marginBottom: 4 }}>SIGNAL TRIGGER</div>
          <div style={{ fontSize: 13, color: THEME.textMain }}>{trigger}</div>
        </div>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: THEME.textMuted, marginBottom: 4 }}>RECOMMENDED PLAY</div>
          <div style={{ fontSize: 13, color: THEME.textMain }}>{action}</div>
        </div>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: THEME.textMuted, marginBottom: 4 }}>EXPECTED OUTCOME</div>
          <div style={{ fontSize: 13, color: THEME.textMain }}>{impact}</div>
        </div>
      </div>
    </div>
  );
}

// --- MAIN APPLICATION ---

export default function App() {
  const [rows, setRows] = useState(INITIAL_DATA);
  const [view, setView] = useState("EXEC");
  const [status, setStatus] = useState("Live Data Loaded");

  useEffect(() => {
    // Try to load full CSV if available, otherwise stick to INITIAL_DATA
    fetch("/sherwin_social_signals_trial.csv")
      .then(res => {
        if(!res.ok) throw new Error("No CSV");
        return res.text();
      })
      .then(csvText => {
        Papa.parse(csvText, {
          header: true, skipEmptyLines: true,
          complete: (res) => {
            // Ensure we filter rows that actually have content
            const clean = (res.data || []).filter(r => r.Snippet && r.Snippet.length > 10);
            if (clean.length > 0) {
                setRows(clean);
                setStatus("Full Dataset Loaded");
            }
          }
        });
      })
      .catch(() => {
        console.log("Using Preloaded Data");
      });
  }, []);

  const analytics = useMemo(() => {
    if (!rows.length) return null;

    // Filters (Loose matching for demo robustness)
    const events = rows.filter(r => 
        (r.SignalTypes || "").toLowerCase().includes("tradeshow") || 
        (r.Themes || "").toLowerCase().includes("tradeshow") ||
        (r.Snippet || "").toLowerCase().includes("booth")
    );
    const launch = rows.filter(r => 
        (r.SignalTypes || "").toLowerCase().includes("launch") || 
        (r.SignalTypes || "").toLowerCase().includes("innovation") ||
        (r.Themes || "").toLowerCase().includes("innovation")
    );
    const customers = rows.filter(r => (r.SignalTypes || "").includes("Customer"));
    
    // Platform Dist
    const platforms = {};
    rows.forEach(r => { platforms[r.Platform] = (platforms[r.Platform] || 0) + 1; });
    const platformData = Object.keys(platforms).map(k => ({ name: k, value: platforms[k] }));

    // BU Dist
    const bus = {};
    rows.forEach(r => {
      if(!r.BusinessUnitsMentioned) return;
      r.BusinessUnitsMentioned.split("|").forEach(b => {
        const clean = b.trim();
        if(clean) bus[clean] = (bus[clean] || 0) + 1;
      });
    });
    const buData = Object.keys(bus).map(k => ({ name: k, value: bus[k] })).sort((a,b) => b.value - a.value).slice(0,5);

    // Timeline
    const timeline = {};
    rows.forEach(r => {
      const d = r.PostDate ? r.PostDate.substring(0, 7) : "Unknown";
      if(d.length === 7) timeline[d] = (timeline[d] || 0) + 1;
    });
    const timelineData = Object.keys(timeline).sort().map(d => ({ date: d, signals: timeline[d] }));

    return { events, launch, customers, platformData, buData, timelineData };
  }, [rows]);

  if (!analytics) return <div style={{ height: "100vh", background: THEME.bg, color: THEME.textMain, display: "flex", alignItems: "center", justifyContent: "center" }}>{status}</div>;

  // --- VIEWS ---

  const renderExec = () => (
    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 24 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          <StatCard title="Total Signals" value={rows.length} sub="Social Mentions" color={THEME.accent} icon={<MessageSquare />} />
          <StatCard title="Event Chatter" value={analytics.events.length} sub="Tradeshow Intent" color={THEME.event} icon={<Tent />} />
          <StatCard title="Innovation Buzz" value={analytics.launch.length} sub="Product Launches" color={THEME.launch} icon={<Zap />} />
        </div>
        <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, padding: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>Social Volume Trend</div>
          <div style={{ height: 250 }}>
            <ResponsiveContainer>
              <AreaChart data={analytics.timelineData}>
                <defs>
                  <linearGradient id="colorVol" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor={THEME.accent} stopOpacity={0.3}/>
                    <stop offset="95%" stopColor={THEME.accent} stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" vertical={false} />
                <XAxis dataKey="date" tick={{fontSize: 10, fill: THEME.textMuted}} axisLine={false} tickLine={false} />
                <YAxis tick={{fontSize: 10, fill: THEME.textMuted}} axisLine={false} tickLine={false} />
                <Tooltip contentStyle={{ backgroundColor: THEME.card, borderColor: THEME.border }} />
                <Area type="monotone" dataKey="signals" stroke={THEME.accent} fill="url(#colorVol)" strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, fontWeight: 700, fontSize: 14 }}>
          Platform Breakdown
        </div>
        <div style={{ flex: 1, minHeight: 200 }}>
           <ResponsiveContainer>
             <PieChart>
               <Pie data={analytics.platformData} innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value">
                 {analytics.platformData.map((entry, index) => (
                   <Cell key={`cell-${index}`} fill={[THEME.accent, THEME.brand, THEME.launch, THEME.event][index % 4]} />
                 ))}
               </Pie>
               <Tooltip contentStyle={{ backgroundColor: THEME.card, borderColor: THEME.border }} />
               <Legend verticalAlign="bottom" wrapperStyle={{fontSize: 11}} />
             </PieChart>
           </ResponsiveContainer>
        </div>
        <div style={{ padding: 20, paddingTop: 0 }}>
          <div style={{ fontSize: 13, color: THEME.textMuted, lineHeight: 1.4 }}>
            <strong>Insight:</strong> Conversation is distributed across LinkedIn (Pro/Biz) and Reddit (Customer/User), giving a balanced view of "Corporate Strategy" vs. "Field Reality."
          </div>
        </div>
      </div>
    </div>
  );

  const renderEvents = () => (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 24 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, padding: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8, color: THEME.event }}>Command Center Stats</div>
          <div style={{ fontSize: 36, fontWeight: 800, color: THEME.textMain }}>{analytics.events.length}</div>
          <div style={{ fontSize: 12, color: THEME.textMuted }}>Booth/Show Signals Detected</div>
          
          <div style={{ marginTop: 24, paddingTop: 24, borderTop: `1px solid ${THEME.border}` }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: THEME.textMuted, marginBottom: 12 }}>TOP SHOWS MENTIONED</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {["SEMA", "Coatings Show", "NAHB", "IBS"].map(s => (
                <span key={s} style={{ fontSize: 11, background: `${THEME.event}20`, color: THEME.event, padding: "4px 8px", borderRadius: 4 }}>
                  {s}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div style={{ background: THEME.bg, border: `1px dashed ${THEME.border}`, borderRadius: 12, padding: 20 }}>
          <div style={{ fontSize: 12, color: THEME.textMuted, marginBottom: 8 }}>STAR OPPORTUNITY</div>
          <div style={{ fontSize: 14, color: THEME.textMain, fontWeight: 600 }}>
            "High booth intent detected for SEMA. Pitch 'Booth Experience Audit' to the Automotive BU."
          </div>
        </div>
      </div>
      
      <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
          <Tent size={16} color={THEME.event} /> Event & Tradeshow Feed
        </div>
        <div style={{ overflowY: 'auto', flex: 1, maxHeight: 600 }}>
          {analytics.events.map((item, i) => (
            <FeedItem key={i} item={item} highlightColor={THEME.event} />
          ))}
        </div>
      </div>
    </div>
  );

  const renderLaunch = () => (
    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 24 }}>
      <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
          <Zap size={16} color={THEME.launch} /> Innovation & Product Feed
        </div>
        <div style={{ overflowY: 'auto', flex: 1, maxHeight: 600 }}>
          {analytics.launch.map((item, i) => (
            <FeedItem key={i} item={item} highlightColor={THEME.launch} />
          ))}
        </div>
      </div>
      <div>
        <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, padding: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>Buzz Keywords</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {["New Formulation", "Sustainable", "Waterborne", "Available Now", "Launch"].map(k => (
              <span key={k} style={{ fontSize: 12, padding: "6px 12px", background: THEME.bg, border: `1px solid ${THEME.border}`, borderRadius: 20, color: THEME.textMain }}>
                {k}
              </span>
            ))}
          </div>
          <div style={{ marginTop: 24, fontSize: 13, lineHeight: 1.5, color: THEME.textMuted }}>
            <strong>Analysis:</strong> Heavy focus on "Sustainability" and "Formulation" indicates a shift towards eco-friendly messaging in R&D launches.
          </div>
        </div>
      </div>
    </div>
  );

  const renderBrands = () => (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
      <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, padding: 24 }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>Business Unit Share of Voice</div>
        <div style={{ height: 300 }}>
          <ResponsiveContainer>
            <BarChart layout="vertical" data={analytics.buData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#334155" horizontal={false} />
              <XAxis type="number" hide />
              <YAxis dataKey="name" type="category" width={140} tick={{fontSize: 11, fill: THEME.textMain}} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ backgroundColor: THEME.card, borderColor: THEME.border }} />
              <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={24} fill={THEME.brand} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div style={{ background: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: 12, padding: 24 }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>Top Brands Mentioned</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {["Sherwin-Williams", "Valspar", "Minwax", "Krylon", "Purdy"].map((b, i) => (
            <div key={b} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 12, borderBottom: `1px solid ${THEME.border}` }}>
              <span style={{ fontSize: 14, fontWeight: 600 }}>{b}</span>
              <span style={{ fontSize: 12, color: THEME.textMuted }}>Rank #{i+1}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderStar = () => (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>STAR Playbook: Social Opportunities</h2>
        <p style={{ color: THEME.textMuted }}>Automated actions based on real-time social intent signals.</p>
      </div>

      <StarPlay 
        title="Tradeshow Staffing Pitch"
        trigger={`High volume of 'Booth' and 'Meet us at' mentions (${analytics.events.length} signals).`}
        action="Offer 'Booth Excellence Training' for their SEMA and Coatings Show teams."
        impact="Ensures their $500k+ booth investment converts into actual leads."
      />

      <StarPlay 
        title="New Product Launch Support"
        trigger={`Surge in 'New Formulation' and 'Launch' keywords (${analytics.launch.length} signals).`}
        action="Propose 'Launch Day Social Room' to manage real-time feedback on Reddit/Twitter."
        impact="Mitigates risk of negative initial reviews and amplifies positive user generated content."
      />

      <StarPlay 
        title="Pro-Painter Community Activation"
        trigger="Consistent engagement on r/paint and Contractor forums detected."
        action="Develop a 'Pro-Influencer' advocacy program."
        impact="Directly influences the Paint Stores Group (PSG) core customer."
      />
    </div>
  );

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: THEME.bg, color: THEME.textMain, fontFamily: "Inter, sans-serif" }}>
      <Sidebar activeView={view} setView={setView} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <div style={{ height: 64, borderBottom: `1px solid ${THEME.border}`, display: "flex", alignItems: "center", padding: "0 32px", justifyContent: "space-between" }}>
          <div style={{ fontWeight: 700 }}>
            {view === "EXEC" && "Social Intelligence Overview"}
            {view === "EVENTS" && "Event Command Center"}
            {view === "LAUNCH" && "Innovation Radar"}
            {view === "BRANDS" && "Brand Share of Voice"}
            {view === "STAR" && "STAR Opportunity Engine"}
          </div>
          <div style={{ fontSize: 12, color: THEME.textMuted }}>{status} • {rows.length} Signals</div>
        </div>
        <div style={{ padding: 32, flex: 1, overflowY: "auto" }}>
          {view === "EXEC" && renderExec()}
          {view === "EVENTS" && renderEvents()}
          {view === "LAUNCH" && renderLaunch()}
          {view === "BRANDS" && renderBrands()}
          {view === "STAR" && renderStar()}
        </div>
      </div>
    </div>
  );
}
